import React, { useEffect } from "react";
import { PRESS_ARTICLES } from "../constants/links";
import "./AboutPage.css";
import { t } from "../i18n";
import { T } from "../i18n/T";

const AboutPage: React.FC = () => {
  useEffect(() => {
    document.title = t("aboutPage.aboutUsRequestApp");
  }, []);

  return (
    <main className="about-page" role="main">
      <header className="about-hero">
        <p className="about-eyebrow">{t("aboutPage.aboutUs")}</p>
      </header>

      <section className="about-articles" aria-label={t("aboutPage.pressArticles")}>
        {PRESS_ARTICLES.map((article) => (
          <a
            key={article.url}
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="about-article-card"
          >
            <div className="about-article-image-wrap">
              <img
                src={article.image}
                alt=""
                className="about-article-image"
                loading="lazy"
              />
            </div>
            <div className="about-article-body">
              <p className="about-article-publication">{article.publication}</p>
              <h2 className="about-article-headline">{article.headline}</h2>
              <p className="about-article-excerpt">{article.excerpt}</p>
            </div>
          </a>
        ))}
      </section>

      <p className="about-contact">
        <T k="aboutPage.contactHelloRequestaApp" tags={{ 0: (c) => <a href="mailto:hello@requesta.app">{c}</a> }} />
      </p>
    </main>
  );
};

export default AboutPage;
